export const theme = {
  colors: {
    primary: '#10b294',
    secondary: '#fb910e',
    secondaryLight: '#F1AE31',
    primaryDark: '#0d9077',
    text: '#787369',
    lightText: '#787369',
    lightGray: '#d6d8dd',
    lighterGray: '#f0f0f0',
    packageLightBlue: '#66C2F2',
    packageDarkBlue: '#3498DB',
    packageLightGreen: '#66D4A8',
    packageDarkGreen: '#2ECC71',
    basicWhite: '#ffffff',
    white: '#fdfdfd',
    transparent: 'transparent',
    green50: '#F0FDF9',
    green100: '#CBFCEE',
    green200: '#97F8DE',
    green300: '#5BEDCB',
    green400: '#2AD7B4',
    green500: '#10B294',
    green600: '#0A977F',
    green700: '#0D7868',
    green800: '#105F54',
    green900: '#124F46',
    green950: '#03302C',
    red50: '#FDF5F3',
    red100: '#FBE9E5',
    red200: '#F9D6CF',
    red300: '#F3BAAE',
    red400: '#EA917F',
    red500: '#DC644C',
    red600: '#CA5038',
    red700: '#A9412C',
    red800: '#8C3928',
    red900: '#753427',
    red950: '#3F1810',
    yellow50: '#FFFAED',
    yellow100: '#FFF3D5',
    yellow200: '#FFE3A9',
    yellow300: '#FECE73',
    yellow400: '#FDAE3A',
    yellow500: '#FB910E',
    yellow600: '#EC770A',
    yellow700: '#C45B0A',
    yellow800: '#9B4711',
    yellow900: '#7D3C11',
    yellow950: '#441D06',
    grey50: '#F8F8F8',
    grey100: '#F0F0F0',
    grey200: '#DCDCDC',
    grey300: '#BDBDBD',
    grey400: '#989898',
    grey500: '#7C7C7C',
    grey600: '#656565',
    grey700: '#525252',
    grey800: '#464646',
    grey900: '#3D3D3D',
    grey950: '#292929'
  },
  spacing: {
    zero: '0px',
    tiny: '2px',
    xsmall: '5px',
    small: '10px',
    mediumSmall: '15px',
    medium: '20px',
    mediumLarge: '25px',
    large: '30px',
    xLarge: '40px'
  },
  fontSizes: {
    xxSmall: '0.6em',
    xsmall: '0.7em',
    small: '0.85em',
    medium: '1em',
    mediumLarge: '1.2em',
    large: '1.5em',
    xLarge: '2.5em',
    xxLarge: '3em'
  },
  responsiveFontSizes: {
    xxSmall: 'min(0.6em, 2.4vw)',
    xSmall: 'min(0.7em, 2.8vw)',
    small: 'min(0.85em, 3.4vw)',
    mediumSmall: 'min(0.92em, 3.7vw)',
    medium: 'min(1em, 4vw)',
    mediumLarge: 'min(1.2em, 4.8vw)',
    large: 'min(1.5em, 6vw)',
    xLarge: 'min(2.5em, 10vw)',
    xxLarge: 'min(3em, 12vw)'
  },
  responsiveSpacing: {
    zero: '0px',
    xsmall: 'min(5px, 1.25vw)',
    small: 'min(10px, 2.5vw)',
    mediumSmall: 'min(15px, 3.75vw)',
    medium: 'min(20px, 5vw)',
    mediumLarge: 'min(25px, 6.25vw)',
    large: 'min(30px, 7.5vw)',
    xLarge: 'min(40px, 10vw)'
  },
  fixedFontSizes: {
    xsmall: '10px',
    small: '13px',
    medium: '16px',
    large: '24px',
    xLarge: '40px',
    xxLarge: '48px'
  },
  breakpoints: {
    mobile: '480px',
    tablet: '768px',
    desktop: '1024px',
    largeDesktop: '1200px'
  },
  maxWidth: '576px'
}

type Theme = typeof theme

declare module 'styled-components' {
  export interface DefaultTheme extends Theme { }
}
